//AUTH
export const AUTH = "AUTH";

//Loyalty
export const UPDATE_LOYALTY = "UPDATE_LOYALTY";
export const UPDATE_LOYALTY_PARTIALY = "UPDATE_LOYALTY_PARTIALY";
export const UPDATE_LOYALTY_REWARDS = "UPDATE_LOYALTY_REWARDS";
export const UPDATE_LOYALTY_REWARDS_PER_LEVEL = "UPDATE_LOYALTY_REWARDS_PER_LEVEL";
export const GET_LOYALTY_REWARDS_PER_LEVEL = "GET_LOYALTY_REWARDS_PER_LEVEL";

//Menu
export const GET_MENU = "GET_MENU";

//Users

export const GET_USER = "GET_USER";
export const REMOVE_USER = "REMOVE_USER";

//restaurants/stores

export const GET_RESTAURANTS = "GET_RESTAURANTS";
